import "react-app-polyfill/stable"
import { browserTracingIntegration, replayIntegration } from "@sentry/react"
import React from "react"
import ReactDOM from "react-dom/client"

import "./index.css"
import "src/i18n.config"
import { App } from "./App"
import { env, locale, platform, version } from "./utilities/constants"
import { initSentry, setSentryTag } from "./utilities/sentry"

initSentry({
  dsn: env.sentry,
  beforeSend: (event, hint) => {
    // require explicit consent
    if (localStorage.getItem("sentry") !== "true") return null
    // If stacktrace shows hls.js
    if (
      event?.exception?.values?.some((v) =>
        v.stacktrace?.frames?.some((f) => f.filename?.includes("hls.js")),
      )
    ) {
      event.level = "info" // or 'debug' instead of 'error'
    }

    // If it's the HlsError object
    if (
      typeof hint.originalException === "object" &&
      hint.originalException !== null &&
      "name" in hint.originalException &&
      hint.originalException?.name === "HlsError"
    ) {
      event.level = "info"
    }

    return event
  },
  integrations: [browserTracingIntegration(), replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/stageplus-smarttv\.dg\.evenly\.app/,
    /^https:\/\/stage-plus\.com/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
setSentryTag("backend_env", env.env)
setSentryTag("backend_locale", locale)
setSentryTag("user_agent", window.navigator.userAgent)
setSentryTag("platform", platform)
setSentryTag("app_version", version)

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
const rootElem = document.getElementById("root")

// override MUI's behavior that inserts aria-hidden tags on root element
if (rootElem) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "aria-hidden" &&
        rootElem.getAttribute("aria-hidden") === "true"
      ) {
        rootElem.removeAttribute("aria-hidden")
      }
    }
  })
  observer.observe(rootElem, {
    attributes: true,
    attributeFilter: ["aria-hidden"],
  })
}

root.render(
  //<React.StrictMode> // this destroys Refs
  <App />,
  //</React.StrictMode>
)
